"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
/**
 * Internationalized messages for this widget
 * These get passed through `React-Intl`
 * And should follow a format of:
 * Roses are {color_1} and violets are {color_2}
 */
const messages = (0, intl_1.defineMessages)({
    // appointment_method.*
    // ===================
    appointmentPhoneTitle: {
        id: 'appointment_method.phone_title',
        description: 'Title when visit type is phone',
        defaultMessage: 'Phone Visit'
    },
    appointmentVideoTitle: {
        id: 'appointment_method.video_title',
        description: 'Title when visit type is video',
        defaultMessage: 'Video Visit'
    },
    appointmentInPersonTitle: {
        id: 'appointment_method.in_person_title',
        description: 'Title when visit type is In Person',
        defaultMessage: 'In Person'
    },
    // appointment_panel.*
    // ===================
    newPatient: {
        id: 'appointment_panel.new_patient_type',
        description: 'A message that reads: New Patient',
        defaultMessage: 'New Patient'
    },
    establishedPatient: {
        id: 'appointment_panel.existing_patient_type',
        description: 'A message that reads: Established Patient',
        defaultMessage: 'Established Patient'
    },
    appointmentDetails: {
        id: 'appointment_panel.appointment_details_header',
        description: 'The heading above the appointment details section of the review and book page',
        defaultMessage: 'Appointment Details'
    },
    // phoneNumberLink_title_attribute.*
    // ===================
    phoneNumberLinkTitle: {
        id: 'phoneNumberLink.title_attribute',
        description: 'Text for HTML title attribute for PhoneNumberLink',
        defaultMessage: 'Call {phone_number}'
    },
    // scheduling.*
    // =============
    schedulingHelp: {
        id: 'scheduling.help',
        description: 'message used for contact help when scheduling appointment',
        defaultMessage: "Need help scheduling an appointment? We're here to help. Call us at {phone_number_link}"
    },
    // aria.*
    // ========
    arialogo: {
        id: 'aria.label.provider.profile.logo',
        description: "Accessibility text for a logo representing a provider's affiliation",
        defaultMessage: 'Logo for {affiliation}'
    },
    ariastarratingsdefault: {
        id: 'aria.label.starratings.default',
        description: "Accessibility label identifying the provider's star ratings",
        defaultMessage: 'Provider star ratings'
    },
    ariastarratingsaverage: {
        id: 'aria.label.starratings.average',
        description: "Accessibility label identifying the provider's star ratings",
        defaultMessage: 'Average provider rating of {averageRating} out of 5 stars'
    },
    locationDistance: {
        id: 'location.distance',
        description: 'Text for the distance to a location',
        defaultMessage: '{distance} miles'
    },
    maplinklabel: {
        id: 'aria.label.maplink',
        description: "Accessibility label for a link to a map of a provider's office",
        defaultMessage: 'Go to a map of {location}'
    },
    mapDistanceLinkLabel: {
        id: 'aria.label.mapdistancelink',
        description: 'Accessibility label for a link to a Google map with distance value',
        defaultMessage: 'Directions to {location}, approximately {distance} miles away'
    },
    ariaBookButton: {
        id: 'aria.label.button.book',
        description: 'Accessibility label for a provider book button',
        defaultMessage: 'Book an appointment with {name}'
    },
    ariaVirtualCareButton: {
        id: 'aria.label.button.virtualCare',
        description: 'Accessibility label for a provider virtual care button',
        defaultMessage: 'Schedule Virtual Care with {name}'
    },
    ariaLocationPhoneNumberLink: {
        id: 'aria.label.link.phoneNumber',
        description: 'Accessibility label for provider phone links',
        defaultMessage: 'Call {locationName} at {phone}'
    },
    ariaLocationFaxNumberLink: {
        id: 'aria.label.link.faxNumber',
        description: 'Accessibility label for provider fax links',
        defaultMessage: 'Fax {locationName} at {fax}'
    },
    ariaProviderProfile: {
        id: 'aria.label.link.providerProfile',
        description: "Accessibility label identifying a link to the provider's profile",
        defaultMessage: '{name}'
    },
    ariaMiniProviderCardPageListLabel: {
        id: 'aria.label.miniProviderCardPage',
        description: 'Accessibility label identifying a mini provider card page',
        defaultMessage: 'Similar Provider'
    },
    ariaMiniProviderCardListLabel: {
        id: 'aria.label.miniProviderCard',
        description: 'Accessibility label identifying a mini provider card page',
        defaultMessage: 'Similar Provider {name}'
    },
    ariaViewAvailability: {
        id: 'aria.label.button.viewAvailability',
        description: 'Call to action button text to view provider appointments',
        defaultMessage: 'View appointments with {name}'
    },
    ariaLiveSearchResultCount: {
        id: 'aria.live.searchResultCount',
        description: 'Text for the number of search results found.',
        defaultMessage: `{count, plural,
        =0 {No results found}
        one {Found # result}
        other {Found # results}
        }`
    },
    // cta.*
    // ========
    ctabutton: {
        id: 'cta.button',
        description: 'Button text to book an appointment with a provider',
        defaultMessage: 'Book Appointment'
    },
    virtualcarebutton: {
        id: 'cta.modal.virtualcare.buttontext',
        description: 'Call to action button text to begin a virtual care session',
        defaultMessage: 'Virtual Care'
    },
    viewAvailability: {
        id: 'cta.viewAvailability.button',
        description: 'Call to action button text to view provider appointments',
        defaultMessage: 'View Appointments'
    },
    viewProfile: {
        id: 'cta.viewProfile.button',
        description: 'Call to action button text to view profile pageppointments',
        defaultMessage: 'View Profile'
    },
    // provider.profile.*
    // ========
    ratingscale: {
        id: 'provider.profile.ratings.scale',
        description: 'Text that specifies the rating scale',
        defaultMessage: 'out of 5'
    },
    ratingcount: {
        id: 'provider.profile.ratings.ratingcount',
        description: 'The number of ratings that the provider has',
        defaultMessage: '{ratingCount} {ratingCount, plural, one {rating} other {ratings}}'
    },
    ratingReviewCount: {
        id: 'provider.profile.ratings.ratingreviewcount',
        description: 'The number of ratings and reviews that the provider has',
        defaultMessage: '{ratingCount} {ratingCount, plural, one {rating} other {ratings}}, {reviewCount} {reviewCount, plural, one {review} other {reviews}}'
    },
    averageRating: {
        id: 'infocard.rating.header',
        description: 'Text for the average rating in provider review summary',
        defaultMessage: '{roundedRating} of 5 stars'
    },
    // providerlist.*
    // ========
    availability: {
        id: 'providerlist.badge.availability',
        description: 'Badge displaying that the provider is available within a certain number of days',
        defaultMessage: `Available within {days, plural,
      one {# day}
      other {# days}
    }`
    },
    miniAvailability: {
        id: 'miniProviderContent.badge.availability',
        description: 'Badge displaying that the provider has available appointments within a certain number of days',
        defaultMessage: `Available {days, plural,
      =0 {today}
      one {within # day}
      other {within # days}
    }`
    },
    miniMoreSpecialties: {
        id: 'miniProviderContent.specialties.more',
        description: 'More text for compact specialties in the mini provider card',
        defaultMessage: 'more'
    },
    miniProviderPageListHeader: {
        id: 'miniproviderList.header',
        description: 'Header text for the similar provider page list',
        defaultMessage: 'Similar Providers'
    },
    directionslink: {
        id: 'providerlist.directionslink',
        description: "Label for a link that links to directions to the provider's office",
        defaultMessage: 'Directions'
    },
    distance: {
        id: 'providerlist.contact.distance',
        description: 'Table header for a column displaying distances',
        defaultMessage: 'Distance'
    },
    hasvideo: {
        id: 'providerlist.hasvideo',
        description: 'Label to identify that the provider has a video on their profile',
        defaultMessage: 'Video'
    },
    virtualproviderdogearbanner: {
        id: 'providerlist.virtualproviderdogearbanner',
        description: 'Banner to identify that the provider has a virtual/video visits',
        defaultMessage: 'Video Visit'
    },
    maplink: {
        id: 'providerlist.maplink',
        description: "Label for a link that links to map showing the location of the provider's office",
        defaultMessage: 'Map'
    },
    onlinebooking: {
        id: 'providerlist.badge.onlinebooking',
        description: 'Badge displaying that the provider accepts online booking',
        defaultMessage: 'Online Booking'
    },
    phone: {
        id: 'providerlist.contact.phone',
        description: 'Table header for a column displaying phone numbers',
        defaultMessage: 'Phone'
    },
    fax: {
        id: 'providerlist.contact.fax',
        description: 'Table header for a column displaying fax numbers',
        defaultMessage: 'Fax'
    },
    location: {
        id: 'providerlist.contact.location',
        description: 'Table header for a column dislaying provider practice locations',
        defaultMessage: 'Practice Locations'
    },
    moreLocationsLink: {
        id: 'providerlist.contact.moreLocationsLink',
        description: 'Text for a link to view more provider locations',
        defaultMessage: 'More locations ({count})'
    },
    action: {
        id: 'providerlist.contact.action',
        description: 'Table header for a column dislaying provider Actions ',
        defaultMessage: 'Actions'
    },
    practiceGroupAlertNoContent: {
        id: 'providerlist.practicegroup.alert.nocontent',
        description: 'Message for practice group alerts with no content available.',
        defaultMessage: 'No content available'
    },
    practiceGroupAlertPracticeHeader: {
        id: 'providerlist.practicegroup.alert.practice.header',
        description: 'Header for practice group practice alerts.',
        defaultMessage: 'Practice Alerts'
    },
    practiceGroupAlertTermHeader: {
        id: 'providerlist.practicegroup.alert.term.header',
        description: 'Header for practice group term alerts.',
        defaultMessage: 'Term Alerts'
    },
    viewAvailabilityProviderTile: {
        id: 'providerlist.cta.viewAvailability.button',
        description: 'Call to action button text to view provider availability',
        defaultMessage: 'View Availability'
    },
    // EstimatedWaitTime
    // ===================
    estimatedWaitTimeButtonLinkName: {
        id: 'providerlist.waitTimeButtonLinkName',
        description: 'Estimated wait time button link name',
        defaultMessage: 'View Estimated Wait Time'
    },
    // provider availability
    // ========
    moreAvailabilitiesLinkText: {
        id: 'availability.more_availability',
        description: 'Text to display on link to view more availabilities',
        defaultMessage: 'View All Appointments'
    },
    availabilityViewMoreAriaLabel: {
        id: 'availability.more_availability.aria_label',
        description: 'Accessibility text to be read by screen reader for provider view more slots',
        defaultMessage: 'view all available appointments for {providerName}'
    },
    availabilityGroupedSlotsAriaLabel: {
        id: 'availability.groupedSlotsAriaLabel',
        description: 'Accessibility text to be read by screen reader for provider available grouped slots',
        defaultMessage: `{count, plural,
    one {# available opening on {date} with {providerName}}
    other {# available openings on {date} with {providerName}}
  }`
    },
    availabilityCountMessage: {
        id: 'availability.count_message',
        description: 'Message to display the number of available appointments',
        defaultMessage: `{count, plural,
      one {# appt}
      other {# appts}
    }`
    },
    bookingOptionsButton: {
        id: 'availability.booking_options_button',
        description: 'Button text to view booking options',
        defaultMessage: 'Booking Options'
    },
    bookingOptionsButtonAriaLabel: {
        id: 'availability.booking_options_button_aria_label',
        description: 'Accessibility text to be read by screen reader for booking options button',
        defaultMessage: 'View booking options for {providerName}'
    },
    ariaLiveLoadingBookingInformation: {
        id: 'availability.aria.live.loading_booking_information',
        description: 'Aria live message for loading booking information',
        defaultMessage: `Loading booking information`
    },
    ariaLiveLoadingBookingInformationComplete: {
        id: 'availability.aria.live.loading_booking_information.complete',
        description: 'Aria live message for loading booking information',
        defaultMessage: `Loading booking information complete`
    },
    availabilityNoMoreRetriesMsg: {
        id: 'availability.no_more_retries',
        description: 'Text to display when no more retries are available',
        defaultMessage: "We're unable to load appointment availability at this time. Please try again later."
    },
    acceptingNewPatientMessage: {
        id: 'providerlist.accepting_new_patient_message',
        description: 'Message to display if the provider is accepting new patients',
        defaultMessage: 'Accepting New Patients'
    },
    // provider facility fee
    clickHere: {
        id: 'link.click_here',
        description: 'Text for a link',
        defaultMessage: 'Click here'
    },
    regulatedSpacesBanner: {
        id: 'info.regulated_spaces_banner',
        description: 'Message used to indicate that a given location on the ApptTime step is a regulated space (additional fees)',
        defaultMessage: 'An additional fee may apply when booking at this location.'
    },
    regulatedSpacesBannerWithLink: {
        id: 'info.regulated_spaces_banner_with_link',
        description: 'Message used to indicate that a given location on the ApptTime step is a regulated space (additional fees)',
        defaultMessage: 'An additional fee may apply when booking at this location. {regulated_spaces_link} for more information.'
    },
    regulatedSpacesBannerLinkTitle: {
        id: 'regulated_spaces_link.title_attribute',
        description: 'Title for the regulated spaces link',
        defaultMessage: 'Information about additional fees at {location_name}'
    }
});
exports.default = messages;
//# sourceMappingURL=messages.js.map